import axios from "axios";
import Serializer from "form-serialize";
import Channels from "../../base/channels";

import "babel-polyfill";

export default class Lazyload {
  constructor(view, type = "") {
    this.view = view;
    this.$trigger = this.view.querySelector(".jsLazyload--trigger");
    this.$receptor = this.view.querySelector(".jsLazyload--receptor");
    this.$form = this.view.querySelector(".jsLazyload--form");
    this.$page = this.view.querySelector(".jsLazyload--page");
    this.TYPE = type;

    // Objects
    this.waypoint = false;
    // States
    this.lazyloadOn = true;
    // Fns
    this.funcResize = this.refresh.bind(this);
    this.events();
  }

  events() {
    if (this.$trigger != null) {
      if (this.$trigger != null) {
        this.$trigger.addEventListener("click", () => {
          this.trigger();
        });
      }

      this.waypoint = new Waypoint({
        element: this.$trigger,
        handler: (direction) => {
          if (direction === "down") {
            this.trigger();
          }
        },
        offset: "200%",
      });

      Channels.on("window::smartresize", this.funcResize);
    }
  }

  destroy() {
    Channels.removeListener("window::smartresize", this.funcResize);
    if (this.waypoint != false) {
      this.waypoint.destroy();
    }
  }

  finalize(response) {
    this.$page.value = this.$page.value * 1 + 1;
    if (response.data.ctaMore == false) {
      this.$trigger.parentElement.classList.add("dp-no");
    }
    this.refresh();
    Channels.emit("lazyload::finalize");
  }

  trigger() {
    if (this.lazyloadOn) {
      this.send();
    }
  }

  refresh() {
    setTimeout(() => {
      if (this.waypoint != false) {
        this.waypoint.context.refresh();
      }
    }, 200);
  }

  send() {
    const datas = Serializer(this.$form, { hash: true });

    axios
      .get(this.$trigger.getAttribute("data-href"), { params: datas })
      .then((response) => {
        const collection = response.data.collection;
        // disabled pagination
        if (response.data.ctaMore == false) {
          this.lazyloadOn = false;
        }
        if (collection.length) {
          for (let i = 0; i < collection.length; i++) {
            const item = collection[i];
            // Dom
            const div = document.createElement("div");
            div.classList.add("mood-index__item");
            div.classList.add("jsIsotope--item");
            div.classList.add("jsLazy--item");
            div.classList.add("jsAccordion--item");
            div.classList.add(`layout--${item.layout}`);
            // Palette

            const colorPalette = "#fff";
            // const colorPalette =
            //   typeof item != "undefined" &&
            //   typeof item.must_acf.palette != "undefined"
            //     ? item.must_acf.palette[0].color
            //     : "#ffffff";

            let htmlShortDescription = "";
            if (
              typeof item.must_acf.short_description != "undefined" &&
              item.must_acf.short_description.length
            ) {
              htmlShortDescription = `
                        <div class="description text__color--white subtitle">
                            <div class="accordion jsAccordion--content"><div class="content ">${item.must_acf.short_description}</div></div>
                        </div>
                        `;
            }
            let $htmlCat = "";
            if (this.TYPE == "mag") {
              for (let super_cat of item.super_categories_rendered) {
                const colorBG = super_cat.acf.color_bg;
                let title = "";
                if (response.data.lang == "en") {
                  title = super_cat.acf.title_en;
                } else {
                  title = super_cat.term.name;
                }
                if (super_cat.term.parent != 0) {
                  $htmlCat += `<p class="category h5 text__color--white" style="background-color: ${colorBG}">${title}</p>`;
                }
              }
            } else {
              $htmlCat = `<p class="category h5 text__color--white text__color--${item.categories_display_slug}">${item.categories_display_name}</p>`;
            }
            const html = `
                    <div class="btn-pin"><a href="https://www.pinterest.com/pin/create/button/" data-pin-do="buttonPin" data-pin-media="${item.visuals.full[0]}" data-pin-url="${item.url_rendered}" data-pin-description="${item.title.rendered}"></a></div>
                    <a href="${item.url_rendered}" class="link-context  jsAccordion--trigger jsUpdateTransition--trigger" data-bg="${colorPalette}">
                        <div class="bg lozad ${item.position_background}" data-background-image="${item.visuals.normal[0]}" data-background-image-set="url('${item.visuals.normal[0]}') 1x, url('${item.visuals.full[0]}') 2x"><img data-src="${item.visuals.normal[0]}" data-srcset="${item.visuals.full[0]} 2x" alt="" class="visuallyhidden lozad"></div>
                        <div class="features">
                            ${$htmlCat}
                            <h3 class="h3 text__color--white">${item.title.rendered}</h3>
                            ${htmlShortDescription}
                            <div class="description is--smaller text__color--white date">${item.date_rendered}</div>
                        </div>
                    </a>`;
            div.innerHTML = html;
            this.$receptor.appendChild(div);
          }
        }
        this.finalize(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}
